import type { CityConfig } from "@/pages/city-template/types";

export const grantsPassConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Grants Pass",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "grants-pass",
  route: "/cities/grants-pass",
  title: "Emergency Passport Grants Pass OR | Expedited Passport Josephine County",
  metaDescription: "Emergency passport and expedited passport services in Grants Pass, OR — as fast as 24 hours. Fast Passport Center serves Josephine County, Rogue River, Cave Junction, and the Illinois Valley. Registered State Dept. courier. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Grants Pass, Oregon",
  heroSubtitle: "Passport expired before your Mexico beach trip or British Columbia fishing adventure? Cruise departing from Seattle in two weeks? Fast Passport Center helps Grants Pass residents get their expedited passport fast — as fast as 24 hours. The nearest passport agency is hundreds of miles away, but we serve you remotely. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Grants%20Pass%20Oregon%20scenic%20Rogue%20River%20flowing%20through%20lush%20forested%20Siskiyou%20Mountains%20valley%2C%20dramatic%20green%20hillsides%20with%20Douglas%20fir%20and%20pine%20forests%2C%20clear%20turquoise%20river%20water%20reflecting%20golden%20afternoon%20sunshine%2C%20wide%20panoramic%20Pacific%20Northwest%20landscape%20photography%2C%20warm%20tones%20with%20vibrant%20green%20foliage%2C%20no%20text%20no%20people%20visible&width=1800&height=700&seq=grants-pass-or-hero-01&orientation=landscape",
  heroImageAlt: "Grants Pass Oregon with the Rogue River flowing through the Siskiyou Mountains",
  geoPosition: "42.4390;-123.3284",
  geoPlacename: "Grants Pass, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 500 miles north — approximately 8 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Grants Pass", zips: "97526, 97527, 97528" },
    { name: "Rogue River", zips: "97537" },
    { name: "Cave Junction", zips: "97523" },
    { name: "Selma", zips: "97538" },
    { name: "Merlin", zips: "97532" },
    { name: "Wilderville", zips: "97543" },
    { name: "Williams", zips: "97544" },
    { name: "Hugo", zips: "97528" },
    { name: "Gold Hill", zips: "97525" },
    { name: "Jacksonville", zips: "97530" },
    { name: "Medford", zips: "97501–97504" },
    { name: "Ashland", zips: "97520" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Grants Pass", desc: "Complete your emergency or expedited passport order from Grants Pass — no 8-hour drive to Seattle required." },
    { icon: "ri-truck-line", title: "Ship Overnight from Grants Pass or Medford", desc: "FedEx and UPS locations in Grants Pass and Medford serve the entire Josephine County area for overnight passport shipping." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — essential for rural Josephine County applicants far from passport agencies." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We bypass the public appointment system with reserved Seattle Passport Agency slots — no 16-hour round trip required." },
  ],
  testimonials: [
    {
      name: "Ben H.",
      location: "Grants Pass, OR",
      rating: 5,
      text: "Booked a Rogue River fishing trip to British Columbia in September and discovered my passport had expired two years prior. Fast Passport Center renewed it in 9 days. I shipped FedEx from Grants Pass and it came back to my door. Outstanding.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Carol T.",
      location: "Grants Pass, OR",
      rating: 5,
      text: "Our family cruise from Vancouver was approaching and my husband realized his passport expired during the pandemic. Fast Passport Center expedited his renewal in 7 days. We're talking about a complex situation and they handled it with zero stress. Incredible.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Mike S.",
      location: "Cave Junction, OR",
      rating: 5,
      text: "Living out in Cave Junction, I assumed I'd have to drive to Portland or somehow get to a passport office. Fast Passport Center was entirely by mail from the Grants Pass FedEx. Passport back in 11 days for my Mexico trip. Couldn't be easier.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "grants-pass-post-main",
      name: "Grants Pass Main Post Office",
      type: "USPS Passport Acceptance",
      address: "215 SE 7th St",
      city: "Grants Pass",
      state: "OR",
      zip: "97526",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm, Sat 10am–2pm",
      distance: "Downtown Grants Pass — primary passport acceptance location for Josephine County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Grants Pass residents. Appointment required — book well in advance during summer and holiday season.",
      icon: "ri-mail-line",
    },
    {
      id: "josephine-county-clerk",
      name: "Josephine County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "500 NW 6th St",
      city: "Grants Pass",
      state: "OR",
      zip: "97526",
      phone: "(541) 474-5151",
      hours: "Mon–Fri 8:30am–4:30pm",
      distance: "Josephine County Courthouse — downtown Grants Pass",
      website: "https://www.co.josephine.or.us/clerk",
      websiteLabel: "Josephine County Clerk",
      notes: "Josephine County Clerk accepts passport applications with good weekday availability. Alternative to the post office when USPS appointments are backed up.",
      icon: "ri-government-line",
    },
    {
      id: "rogue-river-post",
      name: "Rogue River Post Office",
      type: "USPS Passport Acceptance",
      address: "217 E Main St",
      city: "Rogue River",
      state: "OR",
      zip: "97537",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Rogue River — about 10 miles east of Grants Pass",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Rogue River post office — small town location, limited availability. Grants Pass or Medford preferred for rush situations.",
      icon: "ri-mail-line",
    },
    {
      id: "cave-junction-post",
      name: "Cave Junction Post Office",
      type: "USPS Passport Acceptance",
      address: "222 W River St",
      city: "Cave Junction",
      state: "OR",
      zip: "97523",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Cave Junction — about 30 miles southwest via US-199",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Cave Junction post office for Illinois Valley residents — very limited appointment availability. Grants Pass Main Post Office preferred.",
      icon: "ri-mail-line",
    },
    {
      id: "medford-post-main",
      name: "Medford Main Post Office",
      type: "USPS Passport Acceptance",
      address: "3045 E Barnett Rd",
      city: "Medford",
      state: "OR",
      zip: "97504",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm, Sat 10am–2pm",
      distance: "Medford — about 30 miles northeast on I-5, significantly larger facility",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Medford's main post office is the largest acceptance facility in southern Oregon — better appointment availability for Grants Pass residents who make the 30-minute drive.",
      icon: "ri-mail-line",
    },
    {
      id: "gold-hill-post",
      name: "Gold Hill Post Office",
      type: "USPS Passport Acceptance",
      address: "714 2nd Ave",
      city: "Gold Hill",
      state: "OR",
      zip: "97525",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Gold Hill — about 20 miles east toward Medford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small rural post office between Grants Pass and Medford. Limited availability — Grants Pass or Medford preferred.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Grants Pass, Oregon?",
      a: "Yes. Through Fast Passport Center, Grants Pass residents can get an emergency passport in as fast as 24 hours for urgent travel, or 2–9 business days with expedited processing. The nearest regional passport agency is 500 miles north in Seattle — we serve Grants Pass entirely remotely. Start online, ship overnight from Grants Pass FedEx, and we submit through reserved Seattle agency channels.",
    },
    {
      q: "How fast can I renew my passport from Grants Pass?",
      a: "Expedited passport renewal from Grants Pass is available in as little as 3 business days through Fast Passport Center. Most adult renewals do not require an in-person acceptance visit. Ship overnight from the Grants Pass FedEx or UPS location — we handle the agency submission.",
    },
    {
      q: "Does Grants Pass have a passport agency?",
      a: "Grants Pass does not have a regional passport agency. The nearest is the Seattle Passport Agency, approximately 500 miles north (8-hour drive). For Grants Pass area residents, Fast Passport Center is the practical alternative — start online, ship overnight, no Seattle trip required.",
    },
    {
      q: "Where do Grants Pass residents go for passport acceptance?",
      a: "The primary passport acceptance locations near Grants Pass are the Grants Pass Main Post Office (215 SE 7th St), the Josephine County Clerk (500 NW 6th St), and the Medford Main Post Office for better availability (30 miles east). Cave Junction and Rogue River post offices have very limited appointment availability.",
    },
    {
      q: "Can I expedite a passport for a Baja Mexico surf or fishing trip from Grants Pass?",
      a: "Yes. Last-minute Mexico travel is common from Grants Pass — Baja surf trips, Riviera Maya beach vacations, and Puerto Vallarta getaways. Fast Passport Center handles expedited renewals as fast as 3 business days for adult renewal-eligible applicants. Start online as soon as you book your trip.",
    },
    {
      q: "Do Grants Pass residents need a passport for Oregon-to-Vancouver BC travel?",
      a: "A U.S. passport is required for all air travel to Canada. For land crossings, a passport card or NEXUS card works — but Oregon residents cannot get enhanced driver licenses. Most Grants Pass residents heading to British Columbia need a full passport or passport card.",
    },
    {
      q: "How long does standard passport processing take from Grants Pass?",
      a: "Standard USPS mail processing from Grants Pass runs 6–13 weeks during normal periods, and longer during peak summer. If your trip is within 10 weeks, expedited service through Fast Passport Center is strongly recommended.",
    },
    {
      q: "What airport do Grants Pass residents use for international travel?",
      a: "Rogue Valley International–Medford Airport (MFR) is the closest major airport, about 30 miles northeast. For direct international flights, Portland International Airport (PDX) is about 250 miles north with service to Amsterdam, London, Tokyo, Vancouver, and Mexico City. A valid U.S. passport is required for all international departures.",
    },
    {
      q: "Can I renew a passport without visiting an office in Grants Pass?",
      a: "Yes. Most adult Grants Pass residents renewing a passport can do so entirely by mail — no in-person visit required. Start online with Fast Passport Center, complete documents at home, and ship overnight from Grants Pass FedEx or UPS Store. No in-person visit to our facility required.",
    },
    {
      q: "Can I get a child passport expedited from Grants Pass?",
      a: "Yes. Fast Passport Center expedites child passports for Josephine County families. Children under 16 require an in-person acceptance visit with both parents (or notarized consent), so plan accordingly at the Grants Pass Post Office or Josephine County Clerk. After the acceptance step, we handle expedited processing.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Grants Pass", address: "1560 NE 7th St, Grants Pass, OR 97526", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Grants Pass", address: "135 Grants Pass Pkwy, Grants Pass, OR 97527", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "The UPS Store — Grants Pass", address: "1001 NE 5th St, Grants Pass, OR 97526", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 4 PM", website: "https://www.theupsstore.com/" },
    { name: "Fred Meyer — Grants Pass", address: "1625 NE 7th St, Grants Pass, OR 97526", hours: "Daily 7 AM – 11 PM", website: "https://www.fredmeyer.com/" },
    { name: "Rite Aid — Grants Pass", address: "530 NE 7th St, Grants Pass, OR 97526", hours: "Daily 8 AM – 10 PM", website: "https://www.riteaid.com/" },
    { name: "Costco Photo Center — Medford", address: "1255 Center Dr, Medford, OR 97501", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM", website: "https://www.costco.com/" },
    { name: "Walgreens — Medford", address: "3200 Crater Lake Hwy, Medford, OR 97504", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Medford", address: "924 N Central Ave, Medford, OR 97501", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM", website: "https://www.fedex.com/" },
    { name: "Walmart — Rogue River", address: "1201 W Main St, Rogue River, OR 97537", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Ashland", address: "1780 Ashland St, Ashland, OR 97520", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "Grants Pass Driver & Motor Vehicle Services",
      address: "709 NW A St, Grants Pass, OR 97526",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Grants Pass DMV — driver licenses, REAL ID, and ID cards for Josephine County residents.",
      featured: true,
    },
    {
      name: "Medford Driver & Motor Vehicle Services",
      address: "100 E Main St, Medford, OR 97501",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Medford DMV — larger office with better capacity for residents needing REAL ID or expanded services.",
      featured: false,
    },
    {
      name: "Cave Junction Driver & Motor Vehicle Services",
      address: "117 S Cave Ave, Cave Junction, OR 97523",
      hours: "Mon, Wed, Fri 9:00 AM – 4:00 PM",
      note: "Cave Junction branch — limited hours, serves Illinois Valley residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MFR",
      name: "Rogue Valley International–Medford Airport",
      distance: "Primary airport — about 30 miles northeast via I-5",
      address: "1000 Terminal Loop Pkwy, Medford, OR 97504",
      note: "MFR is the primary airport for Grants Pass area travelers, offering connections to Portland, San Francisco, Los Angeles, Seattle, and Las Vegas. International travel requires connecting through a hub. A valid U.S. passport is required for all international departures.",
      flightUrl: "https://www.jacksoncountyor.gov/airport",
      flightLabel: "MFR Airport Website",
      featured: true,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "About 255 miles north via I-5",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International Airport offers direct international flights to Amsterdam, London, Tokyo, Vancouver BC, and Mexico City — accessible for Grants Pass travelers making the 4-hour drive north.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "About 330 miles south via I-5",
      address: "San Francisco, CA 94128",
      note: "SFO is an alternative major international hub for Grants Pass area travelers heading to Asia or South America.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Grants Pass & Josephine County",
      description: "Mexico trip booked spontaneously? Family emergency abroad? Fast Passport Center handles emergency passport processing for Grants Pass residents — as fast as 24 hours. Seattle is 8 hours away, but we serve you remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent and live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired during the pandemic? Grants Pass residents renew fast through Fast Passport Center — ship from local FedEx or UPS overnight, we handle the expedited agency submission.",
      bullets: ["Fastest renewal option for Grants Pass residents", "Ship overnight from Grants Pass or Medford", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in the Rogue Valley or before an international trip? We guide Grants Pass travelers through DS-64 and expedited replacement — no Seattle trip required.",
      bullets: ["DS-64 reporting guidance", "Expedited replacement timelines available", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Rogue Valley Families",
      description: "Josephine County families traveling to British Columbia, Mexico, or internationally with children need child passports. We provide the checklist and handle expedited processing after the local acceptance step.",
      bullets: ["Both parents typically required to consent", "Josephine County Clerk or Post Office guidance", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First-time passport from Grants Pass? We guide you through the acceptance clerk step at the Post Office or County Clerk and handle expedited processing after.",
      bullets: ["Step-by-step acceptance guidance", "Photo location guide for Grants Pass area", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — not a reseller. We submit through reserved agency channels at prices 30–100% lower than retail expediting services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Passport Services",
      description: "Name change after marriage, damaged passport replacement, second passports for Grants Pass professionals and adventurers — all with expedited courier access.",
      bullets: ["Name change passports", "Damaged passport replacement", "Second passport for frequent travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Grants Pass, Oregon travelers with urgent international departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Grants Pass and Josephine County residents needing passports faster than standard USPS timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Grants Pass, Oregon residents — ship overnight from Grants Pass or Medford, we handle the rest." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Grants Pass travelers with lost or stolen passports before travel." },
    { name: "Child Passport", description: "Expedited child passport services for Grants Pass and Josephine County families heading to British Columbia, Mexico, or international destinations." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport submission serving Grants Pass, Oregon and the Josephine County area." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Until the Last Minute — No Nearby Agency Option", description: "The nearest regional passport agency is 8 hours away in Seattle. There is no practical same-day option for Grants Pass residents without a 16-hour round trip. Start Fast Passport Center's expedited service the day you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong or Rejected Passport Photo", description: "Photos from grocery stores frequently get rejected for lighting issues. Fast Passport Center reviews photo specifications before submission to prevent costly rejections." },
    { icon: "ri-file-damage-line", title: "Incomplete or Missing Signatures on Forms", description: "One missing signature returns your application, costing weeks. Our pre-submission review catches all form errors before they become delays." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Format", description: "Short-form birth certificates are typically rejected for passport applications. We specify exactly what document format you need based on your state of birth." },
    { icon: "ri-calendar-close-line", title: "Booking International Adventures Without Checking Passport", description: "Grants Pass outdoor travelers book rafting, fishing, and hunting trips to BC and Mexico months in advance — and discover passport issues only when packing. Check your passport the same day you book." },
    { icon: "ri-map-pin-time-line", title: "Ignoring the Six-Month Validity Rule", description: "Mexico, Canada (by air), and most of Europe require your passport to be valid for six months beyond your return date. A passport expiring in three months is essentially expired for international travel." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Grants Pass travel date. Complete your secure order from home in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist — exactly what to gather, with Grants Pass-specific acceptance location recommendations." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Grants Pass or Medford", description: "Drop off at the Grants Pass FedEx, UPS Store, or Medford FedEx Office — all serve Josephine County with overnight shipping." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — no waiting for public appointments or 16-hour round trips." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped Directly to Grants Pass", description: "Your completed passport ships directly to your Grants Pass or Josephine County address. Track status in real time." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 8 hours each way",
        "Life-or-death emergencies only",
        "Very limited availability",
        "Not practical for Grants Pass residents",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship from Grants Pass or Medford",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks; longer during peak season",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable if travel is under 10 weeks away",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots, weeks out in Seattle", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (8 hours each way from Grants Pass)", fpc: "Ship overnight from Grants Pass or Medford" },
    { feature: "Processing Speed", agency: "Strict eligibility — urgent travel only", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Rural Accessibility", agency: "Not designed for Josephine County residents", fpc: "Fully remote — ship from Grants Pass area" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 16-hour Seattle round trip costs you", fpc: "Best price guarantee — no travel cost" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Medford", route: "/cities/medford" },
    { name: "Emergency passport help in Ashland", route: "/cities/ashland-or" },
    { name: "Fast passport renewal in Klamath Falls", route: "/cities/klamath-falls" },
    { name: "Rush passport services in Roseburg", route: "/cities/roseburg" },
    { name: "Expedited passports for Oregon travelers", route: "/states/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from the Grants Pass FedEx or UPS Store — open evenings. No visit to our processing facility required for most services.",
  fpcOfficeDistance: "Serving Grants Pass and the entire Josephine County area remotely",
  serviceAreaIntro: "Whether you are in Grants Pass, Cave Junction, Rogue River, Selma, Merlin, or anywhere in Josephine County — Fast Passport Center makes emergency and expedited passport processing simple without the 8-hour drive to Seattle.",
  nearbyCitiesIntro: "We serve all Josephine County zip codes and surrounding communities including Cave Junction, Rogue River, Selma, Merlin, Williams, Wilderville, Hugo, Gold Hill, Jacksonville, Medford, and Ashland.",
  howItWorksIntro: "Getting an emergency or expedited passport from Grants Pass is far simpler than an 8-hour drive to Seattle. Most Josephine County clients never visit an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Grants Pass and Josephine County passport applicants. We review your documents before submission to prevent all of them.",
  testimonialsIntro: "Real reviews from Grants Pass, Cave Junction, and Rogue Valley travelers who needed their passports fast.",
  faqIntro: "The most common questions Grants Pass and Josephine County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel & Passport Timing for Grants Pass and Josephine County Residents",
    intro: "Grants Pass is a gateway city for southern Oregon adventure travel — Rogue River rafting, Illinois Valley wilderness, and Crater Lake nearby. Here are the travel patterns and passport urgency triggers we see most from Josephine County clients.",
    cards: [
      {
        icon: "ri-water-flash-line",
        title: "Outdoor Adventure Travel to Canada & Mexico",
        subtitle: "Rogue Valley's outdoor culture drives spontaneous Canada and Mexico travel",
        description: "Grants Pass is the heart of Rogue Valley outdoor recreation — world-class Rogue River whitewater, Illinois Valley hiking, and Oregon Caves nearby. That outdoor culture extends internationally: BC fishing and hunting trips, Mexico beach escapes, and Costa Rica adventure travel. These bookings are often spontaneous — made within 1–4 weeks of departure — and frequently coincide with forgotten passport expiration dates. Grants Pass outdoor enthusiasts should treat passport renewals like equipment maintenance: do it proactively, before it's urgent.",
        tip: "If you book a BC fishing or hunting trip or a Mexico beach vacation in Grants Pass, check your passport the same day. If it expires within 18 months, renew it immediately through Fast Passport Center before the expiration becomes a trip-killer.",
      },
      {
        icon: "ri-ship-2-line",
        title: "Alaska and Canada Cruises from Seattle and Vancouver",
        subtitle: "Southern Oregon travelers book Alaska Inside Passage cruises — all require valid passports",
        description: "Alaska cruises from Seattle are popular with Grants Pass-area retirees and outdoor families. The standard Inside Passage sailings visit Juneau, Glacier Bay, and Ketchikan. All passengers on international sailings require a valid U.S. passport. Canadian departures from Vancouver also require a passport. Grants Pass residents booking an Alaska or Canada cruise should confirm passport validity 6 weeks before departure and order expedited renewal immediately if needed.",
        tip: "Cruise companies require your passport to be valid for the entire voyage — not just the departure date. If your passport expires during an extended cruise, you cannot board. Grants Pass residents should confirm six months of validity beyond the final port of call.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Access via Medford Airport and Portland International",
        subtitle: "MFR is 30 miles away; PDX is 4 hours north with direct international flights",
        description: "Grants Pass residents use Rogue Valley International–Medford Airport (MFR) for regional connections, or drive 255 miles north to Portland International (PDX) for direct international flights. PDX serves Amsterdam, London, Tokyo, Vancouver BC, and Mexico City directly. For South America and Asia, SFO (330 miles south) is another option. International departures from any of these airports require a valid U.S. passport.",
        tip: "For direct international flights, Portland International Airport (PDX) is the most accessible hub from Grants Pass. The 4-hour drive north is worth the direct transatlantic and transpacific connections versus connecting through SFO or LAX.",
      },
      {
        icon: "ri-tree-line",
        title: "Heritage Travel, Family Reunions & Work Abroad",
        subtitle: "Josephine County residents travel for heritage, family, and seasonal work abroad",
        description: "Grants Pass has a significant heritage travel community — Californians who moved north, as well as European-heritage families visiting Germany, Scandinavia, and the UK. Seasonal agricultural workers from Josephine County also travel to Mexico and Central America for family visits. Teaching English abroad programs are popular with Southern Oregon University graduates from nearby Ashland. These diverse travel patterns create steady passport renewal and first-time passport demand year-round.",
        tip: "Heritage travel to Germany, Norway, or the UK often involves visiting elderly relatives — trips that don't allow schedule flexibility. Renew your passport well before a heritage trip, especially if visiting family in a time-sensitive medical situation.",
      },
    ],
    callout: {
      icon: "ri-compass-line",
      title: "Grants Pass — Southern Oregon's Gateway to Adventure Travel",
      description: "Grants Pass is a hub for southern Oregon outdoor culture, connecting Crater Lake to the north, the Rogue River Wilderness to the west, and the Siskiyou Mountains to the south. The city's outdoor-focused community generates steady international passport demand — from BC fishing trips to Mexico surf travel. Fast Passport Center has helped hundreds of Josephine County residents get their passports without a drive to Seattle.",
    },
  },
  destinations: {
    title: "Where Grants Pass Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Grants Pass and Josephine County clients. The Rogue Valley's outdoor culture, retirement community, and proximity to both California and the Pacific create distinctive international travel demand.",
    stats: [
      { stat: "500 mi", label: "to Seattle Passport Agency — 8 hours from Grants Pass via I-5" },
      { stat: "30 mi", label: "to Medford Airport (MFR) — the primary hub for Grants Pass international travel" },
      { stat: "1–4 Wks", label: "typical advance notice when Grants Pass outdoor travelers book international trips" },
      { stat: "24 Hrs", label: "fastest emergency passport processing for eligible Grants Pass residents" },
    ],
    destinations: [
      { name: "British Columbia, Canada", context: "Rogue River fishing community's most popular international destination — BC steelhead rivers, interior elk hunting, Whistler skiing, Okanagan wine country", urgency: "BC licenses and outfitter bookings are made months ahead; passport checks happen only at trip prep time", icon: "ri-map-pin-2-line" },
      { name: "Mexico — Baja, Cabo, Riviera Maya", context: "Winter beach escapes for Grants Pass retirees and families — November through April; spring break Riviera Maya trips", urgency: "October–November Mexico bookings with January–April departures; passports found expired during packing", icon: "ri-sun-cloudy-line" },
      { name: "Alaska Cruise from Seattle", context: "Inside Passage cruises popular with southern Oregon retirees — Glacier Bay, Juneau, Ketchikan, Skagway sailings", urgency: "Summer Alaska cruise bookings in January–February; passport validity discovered during pre-cruise document gathering", icon: "ri-ship-2-line" },
      { name: "Costa Rica & Central America", context: "Eco-adventure travel — cloud forest hiking, Pacific surf, Arenal volcano, and Manuel Antonio wildlife; popular with Rogue Valley outdoor community", urgency: "Adventure travel bookings are often 3–6 weeks out for Josephine County active travelers", icon: "ri-leaf-line" },
      { name: "Europe — Germany, UK, Scandinavia", context: "Heritage travel for Grants Pass families with German, Norwegian, and British ancestry; wine tourism to France and Italy", urgency: "Heritage trips often involve visiting elderly relatives — no schedule flexibility; passport issues discovered close to departure", icon: "ri-map-pin-2-line" },
      { name: "Japan & Pacific Rim", context: "Teaching English abroad programs, technology sector travel, and cultural tourism to Japan, South Korea, and Vietnam from Grants Pass area", urgency: "Teaching programs require passport submission months before departure; discovered at application time", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout southern Oregon with the same expedited passport expertise.",
    crossLinks: [
      { name: "Medford", route: "/cities/medford" },
      { name: "Ashland", route: "/cities/ashland-or" },
      { name: "Klamath Falls", route: "/cities/klamath-falls" },
    ],
  },
};